import { semantic, neutral } from '../../../theme/tokens';

// Beyond this distance (storecheck GPS vs registered PDV) a visit counts as a GPS alert.
export const GPS_ACCURACY_THRESHOLD_M = 500;

// Map/legend colors per accuracy band (solid token colors, so map and table read the same).
export const GPS_COLORS = {
    precise: semantic.success.solid,
    moderate: semantic.warning.solid,
    deviated: semantic.danger.solid,
    none: neutral[400]
};

/** Accuracy band for a storecheck→PDV distance: StatusTag tone, label, tooltip and map color. */
export function getGpsAccuracy(distanceMeters) {
    if (distanceMeters == null) {
        return { tone: 'neutral', color: GPS_COLORS.none, label: 'Sin GPS', description: 'No hay coordenadas de auditoría' };
    }
    if (distanceMeters <= 100) {
        return { tone: 'success', color: GPS_COLORS.precise, label: `${distanceMeters} m`, description: 'Ubicación precisa' };
    }
    if (distanceMeters <= GPS_ACCURACY_THRESHOLD_M) {
        return { tone: 'warning', color: GPS_COLORS.moderate, label: `${distanceMeters} m`, description: 'Desviación moderada' };
    }
    return { tone: 'danger', color: GPS_COLORS.deviated, label: `${distanceMeters} m`, description: 'Desviación significativa del PDV' };
}
